/** Splits a comma/semicolon/whitespace separated list of addresses, de-duplicated. */
export function parseEmailList(raw: string): string[] {
  return [
    ...new Set(
      raw
        .split(/[\s,;]+/)
        .map((e) => e.trim())
        .filter(Boolean),
    ),
  ];
}
